import { css, SerializedStyles } from "@emotion/react";
import { ThemedCssCreator } from "src/config/emotion";

export const androidInputCss = css`
  width: 100%;
`;

export const openButtonCss = css`
  width: 100%;
  text-overflow: ellipsis;
`;

export const fileListContainer = css`
  max-width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: 150px;

  @media (max-width: 991px) {
    & > div:nth-of-type(2) {
      margin-top: 5px;
    }
  }

  @media (min-width: 992px) {
    display: inline-flex;
    flex-direction: row;
    align-items: center;
  }
`;

export const chipCss = css`
  max-width: 100%;
`;

export const multipleContainerCss = css`
  max-width: 100%;
`;

export const noStyleButton = css`
  border: none;
  background-color: transparent;
  padding: 0;
`;

export const fileListItemEmptyCss = css`
  max-width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  @media (max-width: 991px) {
    & > div:nth-of-type(2) {
      margin-top: 5px;
    }
  }

  @media (min-width: 992px) {
    display: flex;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
    & > div:first-of-type {
      width: 70% !important;
    }
  }
`;

export const fileListMultipleFilesWrapper = css`
  padding: 0 4px 4px 4px;
`;

export const fileListItemMargin = css`
  margin-top: 4px;
  width: 100%;
`;

export const fileListWrapperCss = css`
  padding: 0.5rem;
  width: 100%;
  box-sizing: border-box;

  & > div {
    margin-bottom: 0.5rem;
  }
`;

export const singleFileContainer =
  (editMode?: boolean): ThemedCssCreator =>
  ({ colors }): SerializedStyles =>
    css`
      width: ${editMode ? "calc(100% - 35px)" : "100%"};
      height: 35px;
      max-width: 300px;

      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;

      border-radius: 16px;
      border: 1px solid rgba(0, 0, 0, 0.23);
      padding: 1rem 0.5rem;
      cursor: pointer;

      background-color: transparent;

      &:last-child {
        margin-bottom: 0;
      }

      &:hover {
        background-color: rgba(0, 0, 0, 0.04);

        svg {
          color: ${colors.secondaryColor};
          pointer-events: none;
        }
      }

      @media only screen and (max-width: 815px) {
        width: 100%;
      }
    `;

export const fileNameCss = css`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #000;
  font-size: 0.8rem;
  padding: 0 1rem;
`;

export const iconStyleCss: ThemedCssCreator = ({ colors }) => css`
  font-size: 1.2rem !important;
  color: ${colors.primaryColor};
  background-color: transparent;

  &:hover {
    color: ${colors.secondaryColor};
  }
`;

export const filesContainerCss = css`
  box-sizing: border-box;
  padding: 0.5rem;
`;
